module.exports = __webpack_public_path__ + "img/fa25c8a.jpg";